import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { FC } from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';

import { SearchBlockContainer } from '../SearchBlockContainer';
import { ApplicationContext } from '../ApplicationContext';
import { TipsProvider } from '../SearchTipsContainer/provider';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

export const Application: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType} useStaticDeviceType>
          <Provider store={reduxStore}>
            <TipsProvider>
              <SearchBlockContainer />
            </TipsProvider>
          </Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
